import React, { useState } from 'react';
import { Size } from '../../../../Enums/Size.enum';
import FlyerPrintButtonAfterRegistration from '../../../EArchive/Components/FlyerPrint/FlyerPrintButton/FlyerPrintButtonAfterRegistration';
import ConfirmationModal from '../../../Base/Components/Confirmation/ConfirmationModal';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	patientId: string;
	onClose: () => void;
}

const DynamicHealthPlanKDARConfirmationModal: React.FC<Props> = ({
	patientId,
	onClose,
}) => {
	const { t } = useTranslation();
	return (
		<ConfirmationModal
			title='informationMessage.patientsManualRegistrationWithInviteSuccess.titleKDAR'
			text={
				t(
					'informationMessage.patientsManualRegistrationWithInviteSuccess.textKDAR',
				) ?? ''
			}
			imageSource='/dist/icons/v2/check-green.svg'
			isOpen
			onClose={onClose}
			size={Size.LG}>
			<>
				{patientId && (
					<FlyerPrintButtonAfterRegistration
						patientId={patientId}
						onClose={onClose}
					/>
				)}
			</>
		</ConfirmationModal>
	);
};

export default DynamicHealthPlanKDARConfirmationModal;
